const React = require('react')
const { useCallback, useState } = require('react')
const { useHistory } = require('react-router-dom')
const { Row, Col, InputGroup, Input, Button } = require('reactstrap')

const { useSearch, useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

const SearchIcon = require('@assets/icons/searchWhite.svg')
const VBCBanner = require('@assets/banners/vbc.png')
require('@styles/pages/home/searchAndBanner.home.css')

const SearchAndBanner = props => {
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { handleSearch } = useSearch()

    const [searchValue, setSearchValue] = useState('')
    const isMobile = useResponsive(BREAKPOINTS.large)

    const onHandleSearch = useCallback(() => {
        const route = handleSearch(searchValue)
        history.push(`/${network.name}/${route}`)
    }, [searchValue, network, handleSearch, history])

    const onHandleEnter = useCallback(
        e => {
            if (e.key === 'Enter') {
                const route = handleSearch(searchValue)
                history.push(`/${network.name}/${route}`)
            }
        },
        [searchValue, network, handleSearch, history]
    )

    const handleInputChange = useCallback(e => {
        setSearchValue(e.target.value)
    }, [])

    const handlePaste = useCallback(e => {
        e.preventDefault()
        const pastedText = e.clipboardData.getData('text')
        setSearchValue(pastedText)
    }, [])

    return (
        <Row>
            <Col lg='6'>
                <Row>
                    <text className='page-title'>
                        VBchain's Explorer for&nbsp;
                        <span className={`${network.name}-text-color`}>{network.data.name}</span>
                    </text>
                    <InputGroup className='search-wrapper'>
                        <Input
                            className='form-control search-input'
                            placeholder='Search by Address / Txn Hash / Block  / Token'
                            onKeyDown={onHandleEnter}
                            onChange={handleInputChange}
                            onPaste={handlePaste}
                            value={searchValue}
                        />
                        <Button
                            className={`search-icon-wrapper ${network.name}-search-icon-wrapper`}
                            onClick={onHandleSearch}
                        >
                            <img src={SearchIcon} className='search-icon' alt='Search' />
                        </Button>
                    </InputGroup>
                </Row>
            </Col>
            {!isMobile && (
                <Col lg='6' className='d-flex justify-content-end'>
                    <div className='banner-wrapper'>
                        <img src={VBCBanner} className='banner-img' alt='VBC Banner' />
                    </div>
                </Col>
            )}
        </Row>
    )
}

module.exports = {
    SearchAndBanner: React.memo(SearchAndBanner)
}
